import { FC } from 'react';
import { Route, Switch } from 'react-router-dom';
import ClassClass from '../pages/class/class';
import ClassClass2 from '../pages/class/class2';
import ClassNotice from '../pages/class/notice';
import ClassFeedback from '../pages/class/feedback';
import ClassPortfolio from '../pages/class/portfolio';
import PrintAward from '../pages/class/print-award';
import ClassOcean from '../pages/class/ocean';
import ClassLevelUp from '../pages/class/level-up';
import OceanCreate from '../pages/class/ocean/create';
import OceanEdit from '../pages/class/ocean/edit';
import ClassCalendar from '../pages/class/class-calendar';

const ClassRouter: FC = () => {
  return (
    <Switch>
      <Route path="/class/class" exact component={ClassClass} />
      <Route path="/class/notice" exact component={ClassNotice} />
      <Route path="/class/feedback" exact component={ClassFeedback} />
      <Route path="/class/portfolio" exact component={ClassPortfolio} />
      <Route path="/class/ocean" exact component={ClassOcean} />
      <Route path="/class/ocean/create" exact component={OceanCreate} />
      <Route path="/class/ocean/:scheduleCode" exact component={OceanEdit} />
      <Route path="/class/level-up" exact component={ClassLevelUp} />
      <Route path="/class/print-award" exact component={PrintAward} />
      <Route path="/class/class2" exact component={ClassClass2} />
      <Route path="/class/class-calendar" exact component={ClassCalendar} />
    </Switch>
  );
};

export default ClassRouter;
